// packages/ui/src/animationConstants.ts
import { TargetAndTransition, Transition } from 'framer-motion';

export const MAIN_BUTTON_INTERACTION_TRANSITION: Transition = {
  type: "spring",
  stiffness: 300,
  damping: 20,
};

export const MAIN_BUTTON_HOVER: TargetAndTransition = {
  x: -2,
  y: -2,
  boxShadow: `4px 4px 0px 0px rgba(17,24,39, 0.9)`,
};

export const MAIN_BUTTON_TAP: TargetAndTransition = {
  x: 0,
  y: 0,
  boxShadow: `1px 1px 0px 0px rgba(17,24,39,0.4)`,
  scale: 0.98,
};

export const NAV_ICON_BUTTON_HOVER: TargetAndTransition = MAIN_BUTTON_HOVER;
export const NAV_ICON_BUTTON_TAP: TargetAndTransition = MAIN_BUTTON_TAP;
export const NAV_ICON_BUTTON_INTERACTION_TRANSITION: Transition = MAIN_BUTTON_INTERACTION_TRANSITION;